"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PageIndicator = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Pagination_module_scss_1 = __importDefault(require("./Pagination.module.scss"));
var PageIndicator = function (_a) {
    var _b;
    var page = _a.page, selected = _a.selected, ariaLabelPage = _a.ariaLabelPage, onPageClick = _a.onPageClick;
    return (react_1["default"].createElement("button", { type: "button", className: (0, classnames_1["default"])(Pagination_module_scss_1["default"].pageIndicator, (_b = {},
            _b[Pagination_module_scss_1["default"].pageIndicatorSelected] = selected,
            _b)), "aria-label": "".concat(ariaLabelPage || "Page", " ").concat(page), onClick: function () { return onPageClick(page); } },
        react_1["default"].createElement("div", { className: Pagination_module_scss_1["default"].pageIndicatorFocusRing }),
        page));
};
exports.PageIndicator = PageIndicator;
//# sourceMappingURL=PageIndicator.js.map